import { parsePhoneNumberFromString } from 'libphonenumber-js/max';
import createSimpleValidator from './createSimpleValidator';

const errorString = 'Vous devez entrer un numéro de téléphone fixe valide (format international accepté).';

const checkIsValidPhone = createSimpleValidator(
    (value) => {
        if (!value) { return true; }

        const normalizedValue = value.startsWith('+') ? value : `+${value}`;
        const phoneNumber = parsePhoneNumberFromString(normalizedValue);

        if (phoneNumber && phoneNumber.isValid()) {
            const { country } = phoneNumber;
            const type = phoneNumber.getType();
            if ('FIXED_LINE' === type || (('CA' === country || 'US' === country) && 'FIXED_LINE_OR_MOBILE' === type)) {
                return true;
            }

            return false;
        }

        return null;
    },
    errorString,
);

export default checkIsValidPhone;
